export enum EnterpriseLoadingEnum {
    Loading,
    Refreshing,
    LoadingUsers
}

